export const RESET = 'USERDATA_UPDATE_RESET'
export const SET_ERROR = 'USERDATA_UPDATE_SET_ERROR'
export const SET_RETRIEVED = 'USERDATA_UPDATE_SET_RETRIEVED'
export const SET_UPDATED = 'USERDATA_UPDATE_SET_UPDATED'
export const SET_VIOLATIONS = 'USERDATA_UPDATE_SET_VIOLATIONS'
export const TOGGLE_LOADING = 'USERDATA_UPDATE_TOGGLE_LOADING'
export const UPDATE_RETRIEVED = 'USERDATA_UPDATE_UPDATE_RETRIEVED'
export const HANDLE_UPDATE = 'USERDATA_HANDLE_UPDATE'
